import React from 'react';



import '../../styles/Footer/Footer.scss';

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="footer__container">
          <p>
          © 2023 Farhan Shahid
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
